export default __webpack_public_path__ + "static/media/metazuzu.a152f609.png";